import { DelayedAnnouncementModal } from "@/components/DelayedAnnouncementModal";

export const BushCabinPresoldModal = () => (
  <DelayedAnnouncementModal
    storageKey="xpz_bushcabin_presold_notice_seen_2026_v2"
    delayMs={30000}
    testId="bushcabin-presold-modal"
    image="/products/bushcabin/coming-soon-modal.jpg"
    imageAlt="Bushtech Bush Cabin ute camper"
    overline="— High Demand"
    heading="AN ADDITIONAL BATCH IS NOW AVAILABLE FOR SUMMER."
    body="Due to popular demand, we're putting on an additional production batch for summer arrival. We recommend reserving your build now so it's ready to hit the road this summer. Production numbers will be limited, so early reservation is recommended."
    ctaLabel="Reserve Your Build"
    ctaHref="#enquire"
  />
);
